/**
 * Japanese (日本語) — core/shell strings. Product names stay untranslated
 * (brand). Completeness is enforced by the aggregator (ja.ts), so this module
 * is a plain object, not typed as Messages.
 */
const ja = {
  common: {
    initialising: '初期化中…',
    loading: '読み込み中…',
    beta: 'ベータ',
    authUnavailableTitle: '認証を利用できません',
    authUnavailableBody:
      '安全なサインインを初期化できませんでした。接続を確認して再試行してください。',
    retry: '再試行',
  },
  nav: {
    home: 'ホーム',
    diagnosis: 'Diagnosis',
    meshgen: 'MeshGen',
    simops: 'SimOps',
    evaltool: 'EvalTool',
    assistant: 'AI アシスタント',
    feedback: 'フィードバック',
    whatsNew: '新着情報',
    account: 'アカウント',
    logout: 'ログアウト',
    logoutUnavailable: 'ログアウトするアカウントがありません',
  },
  evaltoolLibrary: {
    loadError: 'スタディの読み込みに失敗しました',
    emptyTitle: '評価できるスタディはまだありません',
    emptyHint: '完了した SimOps スタディがここに表示され、レビューできます。',
  },
  whatsNew: {
    title: '新着情報',
    readMore: 'もっと見る',
    more: '他 {{count}} 件',
  },
  account: {
    title: 'アカウント',
    profile: 'プロフィール',
    firstName: '名',
    lastName: '姓',
    email: 'メールアドレス',
    save: '保存',
    saving: '保存中…',
    saved: '保存しました',
    theme: 'テーマ',
    themeLight: 'ライト',
    themeDark: 'ダーク',
    themeSystem: 'システム',
    themeAcademic: 'アカデミック',
    language: '言語',
    signOut: 'ログアウト',
    signOutDescription: 'このデバイスでのセッションを終了します。',
    userId: 'ユーザーID',
    usage: {
      title: 'プランと使用量',
      loadError: 'プランを読み込めませんでした。',
      usageUnavailable:
        '使用量を読み込めませんでした。以下にプランを表示しています。',
      notReadable: '使用量を読み込めませんでした。',
      resetsOn: '{{date}} にリセットされます。',
      trialEndsOn: 'トライアルは {{date}} に終了します。',
      trialNeedsCard:
        'トライアル後もご利用を続けるには、請求ポータルでカードを追加してください。',
      noPeriod:
        '使用量はまだ計測されていません。この組織には請求期間がありません。',
      unlimited: '無制限',
      notIncluded: '対象外',
      notCounted: 'まだ計測されていません。',
      usedThisPeriod: '今期は {{used}} 使用しました。',
      usedOfAllowance: '{{used}} / {{allowance}}',
      remaining: '残り {{remaining}}',
      past: 'プランに含まれる量を {{excess}} 超えています',
      limitReached: '上限に到達',
      extra: '超過',
      cost: '料金',
      rate: '超過分は {{rate}} で請求されます。',
      exhaustedTitle: 'プランに含まれる量をすべて使用しました',
      exhaustedBodyOwner:
        'お支払い方法を追加すると続行できます。期間のリセットをお待ちいただくこともできます。',
      exhaustedBodyMember:
        'この組織のオーナーにお支払い方法の追加を依頼するか、期間のリセットをお待ちください。',
      manage: 'サブスクリプションを管理',
      manageOpening: '開いています…',
      manageFailed: '請求ポータルを開けませんでした。もう一度お試しください。',
      status: {
        active: '有効',
        trialing: 'トライアル',
        pastDue: 'お支払いに失敗',
        unpaid: 'アクセス停止中',
        canceled: '解約済み',
        paused: '一時停止中',
      },
      seatsPurchasedProduct_one: '{{product}}: 有料シート {{count}} 件',
      seatsPurchasedProduct_other: '{{product}}: 有料シート {{count}} 件',
      seatsPurchasedProductScheduled_one:
        '{{product}}: 有料シート {{count}} 件、{{date}} から {{scheduled}} 件',
      seatsPurchasedProductScheduled_other:
        '{{product}}: 有料シート {{count}} 件、{{date}} から {{scheduled}} 件',
      buy: 'シートを購入',
      changePlan: 'プランを変更',
      pendingTitle: 'お支払いを受け付けました',
      pendingBody: 'プランを更新しています。通常は数秒で完了します。',
      pendingSlowBody:
        'プランの更新に通常より時間がかかっています。お支払いは完了していますので、しばらくしてからご確認ください。',
      dunningRetryingTitle: 'カード情報を更新してください',
      dunningRetryingBody:
        '前回のお支払いに失敗しました。アクセスを維持するにはカード情報を更新してください。',
      dunningPausedTitle: 'サブスクリプションが未払いです',
      dunningPausedBody:
        '未払いの請求書が支払われるまでアクセスを停止しています。請求ポータルでカード情報を更新し、お支払いください。',
      updateCard: 'カード情報を更新',
      cancelledTitle: 'チェックアウトをキャンセルしました',
      cancelledBody: '請求は発生していません。',
      dismiss: '閉じる',
      ownerOnly: 'サブスクリプションを変更できるのは組織のオーナーのみです。',
      pendingChangeTitle: '予約済みの変更',
      pendingChange:
        '{{product}}: {{date}} まで {{current}}、その後 {{next}}。',
      pendingChangeRemoved:
        '{{product}}: {{date}} まで {{current}}、その後は削除。',
      pendingChangeTo: '{{product}}: {{date}} から {{next}}。',
      pendingChangeDropped: '{{product}}: {{date}} から削除。',
      pendingChangeSeats_one: '{{product}}: {{date}} から {{count}} シート。',
      pendingChangeSeats_other: '{{product}}: {{date}} から {{count}} シート。',
      cancelScheduled: '予約済みの変更を取り消す',
      cancelScheduledPending: '取り消しています…',
      cancelScheduledFailed:
        '予約済みの変更を取り消せませんでした。もう一度お試しください。',
    },
    workspaces: {
      title: 'ワークスペース',
      description:
        '複数のワークスペースに所属しています。切り替えるとアプリが再読み込みされ、選択したワークスペースにサインインします。',
      current: '現在',
      switch: '切り替え',
      switching: '切り替え中…',
      switchError:
        'そのワークスペースを開けませんでした。もう一度お試しいただくか、サインアウトしてからそのワークスペースにサインインしてください。',
    },
    organization: {
      title: '組織',
      loading: '組織を読み込み中…',
      loadError: '組織情報を読み込めませんでした。',
      unavailableTitle: '組織を利用できません',
      unavailableBody: 'アカウントはまだ有効な組織に関連付けられていません。',
      teamLabel: 'ワークスペース',
      readOnlyTitle: 'ワークスペースメンバーシップ',
      readOnlyBody:
        'メンバーとメールアクセスドメインを管理できるのは組織オーナーのみです。あなたのアクセスは変わりません。',
      organizationId: '組織ID',
      yourRole: 'あなたのロール',
      ownerControls: 'オーナー管理',
      statusActive: '有効',
      statusSuspended: '停止中',
      billingBoundaryTitle: 'メンバーシップと請求は別です',
      billingBoundaryBody:
        'ここでのメンバー変更では、プラン開始や課金対象シート数の同期は行われません。商用プロビジョニングは別管理です。',
      renameTitle: 'ワークスペース名',
      renameDescription:
        'ワークスペース選択画面と招待メールでメンバーに表示されます。',
      renameLabel: '名前',
      saveName: '名前を保存',
      renamed: 'ワークスペース名を保存しました。',
      domainsTitle: 'メールアクセスドメイン',
      domainsDescription:
        'StytchのメールJITアクセスを次のドメインに制限します。',
      domainsOwnershipBoundary:
        'この許可リストはDNS所有権を証明せず、それだけでKhoriumメンバーシップを作成することもありません。Stytchでは検証済みメールアドレスが必要です。',
      domainsLabel: '許可ドメイン',
      domainsPlaceholder: 'example.com\nsubsidiary.example',
      domainsEmpty: '許可ドメインはありません。メールJITアクセスは無効です。',
      saveDomains: 'ドメインを保存',
      domainsSaved: 'メールアクセスドメインを保存しました。',
      membersTitle: 'メンバー',
      memberCount: '{{count}}人のメンバー',
      seatsProductAssigned: '{{product}} {{purchased}} 席中 {{assigned}} 席',
      seatsProductAssignedScheduled:
        '{{product}} {{purchased}} 席中 {{assigned}} 席（更新時に {{scheduled}} 席）',
      seatsProductUnlimited: '{{product}} {{count}} 席 · 上限なし',
      seatsUnavailable: '席数の上限を取得できません',
      seatsRetry: '再試行',
      seatUnassigned: '席なし',
      assignProductSeat: '{{product}} の席を割り当て',
      unassignProductSeat: '{{product}} の席を解除',
      inviteTitle: 'メンバーを招待',
      inviteDescription:
        '招待を承諾するとチームメンバーになります。アプリ権限はリソース共有とは別に選択します。',
      emailLabel: 'メールアドレス',
      emailPlaceholder: 'name@company.com',
      inviteRole: '組織ロール',
      invite: '招待を送信',
      inviting: '送信中…',
      inviteSent: '{{email}} に招待を送信しました。',
      noMembers: 'メンバーが見つかりません。',
      you: 'あなた',
      roleOwner: 'オーナー',
      roleAdmin: '管理者',
      roleMember: 'メンバー',
      statusInvited: '招待済み',
      changeRole: 'ロールを変更',
      suspend: '停止',
      reactivate: '再有効化',
      remove: '削除',
      transferOwnership: '所有権を移譲',
      roleConfirmTitle: '{{email}} を{{role}}に変更しますか？',
      roleConfirmBody:
        '変更されるのは組織権限のみです。既存のリソース共有は別に維持されます。',
      suspendConfirmTitle: '{{email}} を停止しますか？',
      suspendConfirmBody:
        'アクセスは直ちに停止し、所有プロジェクトは現在のオーナーへ移ります。再有効化しても以前の所有権は戻りません。',
      reactivateConfirmTitle: '{{email}} を再有効化しますか？',
      reactivateConfirmBody:
        '現在のロールでチームアクセスが戻ります。停止中に移されたプロジェクトは現在のオーナーに残ります。',
      removeConfirmTitle: '{{email}} を削除しますか？',
      removeConfirmBody:
        'メンバーシップを削除し、所有プロジェクトを現在のオーナーへ移します。コメントと既存のリソース共有は残ります。',
      transferConfirmTitle: '{{email}} に所有権を移譲しますか？',
      transferConfirmBody:
        'あなたは管理者になり、選択したメンバーが唯一のオーナーになります。請求は別管理で、移動も開始もされません。',
      confirm: '確認',
      cancel: 'キャンセル',
      updating: '更新中…',
      roleUpdated: 'ロールを更新しました。',
      memberSuspended: 'メンバーを停止しました。',
      memberReactivated: 'メンバーを再有効化しました。',
      memberRemoved: 'メンバーを削除しました。',
      ownershipTransferred: '所有権を移譲しました。',
      actionFailed: '操作を完了できませんでした: {{reason}}',
      retry: '再試行',
    },
  },
  checkout: {
    title: 'シートを購入',
    subtitle: '組織に必要なものと、それぞれのシート数を選んでください。',
    productsLabel: '含める項目',
    productMeshgenBody: 'ジオメトリからメッシュを生成します。',
    productSimopsBody: 'シミュレーションとスタディを実行します。',
    productDiagnosisBody: 'メッシュ化の前にジオメトリの問題を確認します。',
    tierNone: 'なし',
    tierNoneBody: '含まれません。',
    currentPlan: '現在のプラン',
    tierBody: '1 シートあたり月 {{included}} · 1 シート ${{price}}',
    overageNote:
      '含まれる分数を超えた分は 1 時間 ${{rate}} で継続して実行され、月ごとに請求されます。',
    seatsFor: '{{product}} のシート数',
    seatsHelp:
      'そのプロダクトで作業を実行する人ごとに 1 シートです。購入後にメンバーへ割り当てられます。',
    lineItem_one: '{{plan}} · {{count}} シート · 月 ${{amount}}',
    lineItem_other: '{{plan}} · {{count}} シート · 月 ${{amount}}',
    total: '月 ${{amount}}',
    trialTotal: '{{days}} 日間無料、その後月 ${{amount}} — カードが必要です。',
    priceNote: '次のページでお支払い前に確認できます。',
    submit: 'お支払いへ進む',
    submitting: 'チェックアウトを開いています…',
    failed: 'チェックアウトを開けませんでした。請求は発生していません。',
    ownerOnly: 'シートを購入できるのはこの組織のオーナーのみです。',
    unavailable: 'シートの購入はまだご利用いただけません。',
    backToAccount: 'アカウントに戻る',
    changeTitle: 'プランを変更',
    changeOwnerOnly: 'プランを変更できるのはこの組織のオーナーのみです。',
    changeUnavailable: 'プランの変更はまだご利用いただけません。',
    changePaused:
      '前回のお支払いに失敗したため、アクセスを停止しています。プランを変更する前に、アカウントページから請求ポータルで未払いの請求書をお支払いください。',
    changeSubtitle:
      '各プロダクトを「なし」「Basic」「Plus」の間で変更し、それぞれのシート数を設定できます。',
    changeNote:
      '上位プランへの変更やシートの追加は本日請求され、すぐに反映されます。下位プランへの変更やシートの削減は次回の更新日に反映され、請求も返金もありません。',
    changeSubmit: 'プランを変更',
    changeSubmitting: 'プランを変更しています…',
    submitPayToday: '本日 {{amount}} を支払う',
    submitSchedule: '変更を予約',
    submitPayAndSchedule: '本日 {{amount}} を支払い、残りを予約',
    changeFailed: 'プランを変更できませんでした。請求は発生していません。',
    cardDeclined:
      'カードが拒否されたため、何も変更されていません。請求ポータルでカードを更新して、もう一度お試しください。',
    cancelScheduledFirst:
      'すでにプラン変更が予約されています。先にアカウントページで取り消してください。',
    changeDone:
      'プランを変更しました。画面に反映されるまで少し時間がかかることがあります。',
    changeScheduled:
      'プランを変更しました。下位プランへの部分は {{date}} に反映されます。画面に反映されるまで少し時間がかかることがあります。',
    changePickAPlan:
      'すべてのプロダクトでプランを選ぶと、費用と反映日が表示されます。',
    changeNothingYet: '別のプランを選ぶと、費用と反映日が表示されます。',
    changeKeepOne:
      '少なくとも 1 つのプロダクトを残してください。サブスクリプションを終了するには、アカウントページの「サブスクリプションを管理」をご利用ください。',
    currentPlanUnknown:
      'このプロダクトの現在のプランはここにある 3 つのいずれでもありません。ご希望のプランを選んでください。',
    seatsUnbounded: 'このプロダクトにシート数の上限はありません。',
    changeSeatsInvalid:
      'すべてのプロダクトに 1〜100 のシート数を設定すると、費用が表示されます。',
    seatsBelowAssignedLine:
      '{{product}}: {{assigned}} 人のメンバーが席を持っていますが、{{requested}} シートが指定されています。',
    seatsBelowAssigned:
      'シート数を席を持つメンバーの人数より少なくすることはできません。先にメンバーから席を解除してください。',
    manageSeats: 'アカウントページで席を管理',
    chargedToday: '本日の請求額: {{amount}}',
    scheduledFrom: '{{date}} から: {{plans}}',
    scheduledFromUndated: '次回の更新日から: {{plans}}',
    nothingToday: '本日の請求はありません。',
    previewPending: '費用を計算しています…',
    previewFailed: '費用を計算できませんでした。',
  },
  home: {
    greetingMorning: 'おはようございます、',
    greetingAfternoon: 'こんにちは、',
    greetingEvening: 'こんばんは、',
    fallbackName: 'ゲスト',
    importRepair: '修復',
    importMesh: 'メッシュ',
    newStudy: '新しいスタディ',
    noProjects:
      'プロジェクトはまだありません。ファイルをアップロードして始めましょう。',
    ask: {
      heading: '何に取り組みますか？',
      placeholder: 'メッシュ・スタディ・失敗について質問する…',
      submit: '質問',
      footnote: '質問はアシスタントを全画面で開き、新しい会話になります。',
      dropHint:
        'CADパーツをここにドロップするか添付すると、アシスタントに質問できます。',
      dropActive: 'ドロップして質問に添付',
      leadSuggestion: '{{name}} はなぜ失敗しましたか？再試行すべきですか？',
      suggestionFailure: '直近のメッシュはなぜ失敗しましたか？',
      suggestionSummarise: '実行中のスタディのここまでを要約して',
      suggestionStudy: 'メッシュからスタディを設定するには？',
    },
    work: {
      title: 'あなたの作業',
      onYou: '対応待ち {{count}} 件',
      review: '確認',
      reviewRetry: '再試行を確認',
      empty: '実行中の作業も、対応待ちもありません。',
      error: '作業を読み込めませんでした。',
      partial: '一部の作業を読み込めませんでした。',
      allActivity: 'すべてのアクティビティ',
    },
    recents: {
      title: '最近の作業',
      allMeshes: 'すべてのメッシュ',
      allStudies: 'すべてのスタディ',
      filterAll: 'すべて',
      filterMeshing: 'メッシュ',
      filterStudies: 'スタディ',
      count: '直近 {{count}} 件',
      countOf: '{{total}} 件中 {{shown}} 件',
      emptyFilter: 'この分類に最近の作業はありません。',
      error: '最近の作業を読み込めませんでした。',
      partial: '一部の最近の作業を読み込めませんでした。',
    },
  },
};

export default ja;
